import type { ActivationStep } from "./types";

export const GET_STARTED_PATH = "/procure/get-started";
export const LEARN_PATH = "/procure/learn";

export const learnHref = (placement?: string) =>
  placement
    ? `${LEARN_PATH}?placement=${encodeURIComponent(placement)}`
    : LEARN_PATH;

/** Strip a trailing "(optional)" — the UI shows an "Optional" badge instead. */
export const displayTitle = (title: string) =>
  title.replace(/\s*\(optional\)\s*$/i, "").trim();

/** The first incomplete required step, or the first incomplete step at all. */
export const nextStep = (steps: ActivationStep[]) =>
  steps.find((step) => step.required && !step.completed) ??
  steps.find((step) => !step.completed) ??
  null;

/** The floating checklist is only offered to accounts newer than this. */
export const NEW_CUSTOMER_WINDOW_DAYS = 30;

export const isNewCustomer = (createdAt?: string | null, now = Date.now()) => {
  if (!createdAt) return false;
  const created = new Date(createdAt).getTime();
  if (Number.isNaN(created)) return false;
  return now - created <= NEW_CUSTOMER_WINDOW_DAYS * 24 * 60 * 60 * 1000;
};
